const PLACEHOLDER_PATTERN = /\{([^}]+)\}/g

function formatMessage (message, context = {}) {
  return message.replace(PLACEHOLDER_PATTERN, (_match, key) => {
    if (/^\d+$/.test(key) && typeof context.list === 'function') {
      const value = context.list(Number(key))
      return value == null ? '' : value
    }

    if (typeof context.named === 'function') {
      const value = context.named(key)
      return value == null ? '' : value
    }

    return ''
  })
}

function createMessageFunction (message) {
  const pluralMessages = message.split('|').map(value => value.trim())

  return context => {
    if (pluralMessages.length > 1 && typeof context?.plural === 'function') {
      return context.plural(pluralMessages)
    }

    return formatMessage(message, context)
  }
}

export function createCspSafeMessages (messages) {
  return Object.entries(messages).reduce((compiled, [key, value]) => {
    compiled[key] = value && typeof value === 'object'
      ? createCspSafeMessages(value)
      : createMessageFunction(String(value))

    return compiled
  }, {})
}
